import { useLayoutEffect, useMemo, useRef, useState } from "react";
import { IndiaMap as ReactIndiaMap } from "@vishalvoid/react-india-map";
import { Mail, MapPin, Phone } from "lucide-react";

// ---------------------------------------------------------------------------
// Data
// ---------------------------------------------------------------------------

const offices = [
  {
    key: "jammu",
    tab: "Jammu",
    mapLabel: "JAMMU",
    title: "State Office, Jammu",
    stateId: "IN-JK",
    // contact: "Mr. Amit Khajuria",
    // address:
    //   "Shree Toyota, Batra Group Complex, \n Milestone Zero, Narwal Bala, Jammu – 180 001",
    phone: "+91 98882 08880",
    email: "bharti.sood@assoccham.com",
    marker: { x: "30.4%", y: "6.4%" },
  },
  {
    key: "punjab",
    tab: "Punjab",
    mapLabel: "PUNJAB",
    title: "State Office, Punjab",
    stateId: "IN-PB",
    // contact: "Mr. Ravinder Chandla",
    address:
      "Punjab Innovation Mission, Kalkat Bhawan, Block-C, Aerocity, Airport Road, Sahibzada Ajit Singh Nagar, Mohali, Punjab 140603",
    phone: "+91 98882 08880",
    email: "bharti.sood@assoccham.com",
    marker: { x: "35.2%", y: "24.9%" },
  },
  {
    key: "delhi",
    tab: "HQ - New Delhi",
    mapLabel: "NEW DELHI",
    title: "ASSOCHAM HQ",
    stateId: "IN-DL",
    contact: "",
    address:
      "ASSOCHAM, 4th Floor, YMCA Cultural Centre and Library Building, 01, Jai Singh Road, New Delhi - 110001",
    phone: "011-46550555",
    email: "",
    marker: { x: "32.7%", y: "34.9%" },
  },
  {
    key: "rajasthan",
    tab: "Rajasthan",
    mapLabel: "RAJASTHAN",
    title: "State Office, Rajasthan",
    stateId: "IN-RJ",
    contact: "Mr. Dinesh Mathur",
    address:
      "Creware Business, 1st Floor, 150/21, Shipra Path, Mansarovar, Jaipur, Rajasthan – 302020",
    phone: "9587495333",
    email: "dinesh.mathur@assocham.com",
    marker: { x: "18.4%", y: "33.4%" },
  },
  {
    key: "up",
    tab: "Uttar Pradesh",
    mapLabel: "UTTAR PRADESH",
    title: "State Office, Uttar Pradesh",
    stateId: "IN-UP",
    // contact: "Mr. Akshay Dubey",
    // address:
    //   "12th Floor, Wing B, Summit Space, Summit Building, Vibhuti Khand, Gomti Nagar, Lucknow, Uttar Pradesh 226010",
    phone: "+91 94150 23302",
    email: "rajeev.dixit@assocham.com",
    marker: { x: "47.3%", y: "34.9%" },
  },
  {
    key: "assam",
    tab: "Assam",
    mapLabel: "ASSAM",
    title: "State Office, Assam",
    stateId: "IN-AS",
    // contact: "Mr. Himraj Das",
    // address: "H.No- 55, Batahghuli, Panjabari, Guwahati, Assam – 781037",
    // phone: "7002349936",
    email: "bibhuti.dutta@assocham.com",
    marker: { x: "84.6%", y: "34.3%" },
  },
  {
    key: "gujarat",
    tab: "Gujarat",
    mapLabel: "GUJARAT",
    title: "State Office, Gujarat",
    stateId: "IN-GJ",
    contact: "Mr. Vipul Gajingwar",
    address:
      "608, 6th Floor, SAKAR III, Opposite Old High Court, Income Tax Cross Road, Ashram Road, Ahmedabad, Gujarat – 380014",
    phone: "079-2754 1728-29 / 2754 1876",
    email: "vipul.bg@assocham.com",
    marker: { x: "12.1%", y: "47.7%" },
  },
  {
    key: "westbengal",
    tab: "West Bengal",
    mapLabel: "WEST BENGAL",
    title: "State Office, West Bengal",
    stateId: "IN-WB",
    contact: "Mr. Ramit Sircar",
    address:
      "Signet Tower, Unit 1002, 10th Floor, DN-2, Salt Lake, Sector V, Kolkata, West Bengal 700091",
    phone: "+91 9830468951",
    email: "ramit.sircar@assocham.com",
    marker: { x: "68.5%", y: "46.8%" },
  },
  {
    key: "maharashtra",
    tab: "Maharashtra",
    mapLabel: "MAHARASHTRA",
    title: "State Office, Maharashtra",
    stateId: "IN-MH",
    // contact: "Ms. Sumita Chakravarty",
    address:
      "EFC Limited - Plot No. 15, Sr. No. 5A, The Centrium – 3rd Floor, Village Kurla Kirol, L.B.S. Marg, Kurla West, Mumbai – 400070",
    phone: "+91 91670 90555",
    email: "robin.rosario@assocham.com",
    marker: { x: "19.1%", y: "62.0%" },
  },
  {
    key: "odisha",
    tab: "Odisha",
    mapLabel: "ODISHA",
    title: "State Office, Odisha",
    stateId: "IN-OR",
    contact: "Mr. Priyabrata Mishra",
    address:
      "Workloop Co-Office, No. 316, Esplanade One Mall, Rasulgarh, Bhubaneswar, Odisha – 751010",
    phone: "9437946511",
    email: "priyabrata.mishra@assocham.com",
    marker: { x: "58.1%", y: "57.3%" },
  },
  {
    key: "goa",
    tab: "Goa",
    mapLabel: "GOA",
    title: "State Office, Goa",
    stateId: "IN-GA",
    contact: "Ms. Darshana Kossambe",
    address:
      "Dempo Trade Center, Ground Floor, MeWo Co-Working, Next to Bank of India Building, Patto, Panaji, Goa – 403001",
    phone: "9763788399",
    email: "darshana.kossambe@assocham.com",
    marker: { x: "20.8%", y: "69.5%" },
  },
  {
    key: "telangana",
    tab: "Telangana / AP",
    mapLabel: "TELANGANA",
    title: "State Office, Telangana / Andhra Pradesh",
    stateId: "IN-TG",
    contact: "Mr. Macha Dinesh Babu",
    address:
      "C/o: AXIS Energy Group, Wing 2, Level 6, Block-D, Cyber Gateway, Madhapur, Hyderabad – 500081",
    phone: "8008234556",
    email: "macha.dinesh@assocham.com",
    marker: { x: "42.3%", y: "69.2%" },
  },
  {
    key: "karnataka",
    tab: "Karnataka",
    mapLabel: "KARNATAKA",
    title: "State Office, Karnataka",
    stateId: "IN-KA",
    contact: "Ms. Uma S. Nair",
    address:
      "C/o: Rainmakers Workspace, #213, 2nd Floor, Ramanashree Arcade, 18 MG Road, Bangalore - 560001",
    phone: "9036333975",
    email: "uma.nair@assocham.com",
    marker: { x: "28.6%", y: "79.3%" },
  },
  {
    key: "tamilnadu",
    tab: "Tamil Nadu",
    mapLabel: "TAMIL NADU",
    title: "State Office, Tamil Nadu",
    stateId: "IN-TN",
    // contact: "Ms. Uma S. Nair",
    address: "",
    phone: "+91 9361986450",
    email: "suresh.rajendran@assocham.com",
    marker: { x: "33.4%", y: "86.7%" },
  },
  {
    key: "kerala",
    tab: "Kerala",
    mapLabel: "KERALA",
    title: "State Office, Kerala",
    stateId: "IN-KL",
    contact: "Ms. Uma S. Nair",
    address: "",
    phone: "9036333975",
    email: "uma.nair@assocham.com",
    marker: { x: "29.4%", y: "94.7%" },
  },
];

const MAP_WIDTH = 611.86;
const MAP_HEIGHT = 695.7;

function mapSearchUrl(address) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

// ---------------------------------------------------------------------------
// IndiaMap
// ---------------------------------------------------------------------------

function IndiaMap({ selected, onSelect }) {
  const wrapperRef = useRef(null);
  const mapHolderRef = useRef(null);
  const [transform, setTransform] = useState({ scale: 1, x: 0, y: 0 });

  const officeByStateId = useMemo(
    () => Object.fromEntries(offices.map((office) => [office.stateId, office])),
    []
  );

  const stateData = useMemo(
    () =>
      offices.map((office) => ({
        id: office.stateId,
        customData: { name: office.mapLabel },
      })),
    []
  );

  useLayoutEffect(() => {
    const wrapper = wrapperRef.current;
    const holder = mapHolderRef.current;
    if (!wrapper || !holder) return undefined;

    function fitMap() {
      const svg = holder.querySelector("svg");
      if (!svg) return;

      svg.removeAttribute("style");
      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");

      const wrapperRect = wrapper.getBoundingClientRect();
      const scale = Math.min(wrapperRect.width / MAP_WIDTH, wrapperRect.height / MAP_HEIGHT);

      setTransform({
        scale,
        x: (wrapperRect.width - MAP_WIDTH * scale) / 2,
        y: (wrapperRect.height - MAP_HEIGHT * scale) / 2,
      });
    }

    fitMap();
    const observer = new MutationObserver(fitMap);
    const resizeObserver = new ResizeObserver(fitMap);
    observer.observe(holder, { childList: true, subtree: true });
    resizeObserver.observe(wrapper);

    return () => {
      observer.disconnect();
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className="relative w-[min(100%,290px)] overflow-hidden rounded-[14px] bg-white shadow-[0_16px_36px_rgba(116,35,0,0.15)]"
      style={{ aspectRatio: `${MAP_WIDTH} / ${MAP_HEIGHT}` }}
    >
      <div
        ref={mapHolderRef}
        className="assocham-map absolute left-0 top-0"
        style={{
          width: `${MAP_WIDTH}px`,
          height: `${MAP_HEIGHT}px`,
          transform: `translate(${transform.x}px, ${transform.y}px) scale(${transform.scale})`,
          transformOrigin: "top left",
        }}
      >
        <ReactIndiaMap
          stateData={stateData}
          mapStyle={{
            backgroundColor: "#f7f7f7",
            hoverColor: "#ededed",
            stroke: "#b8b8b8",
            strokeWidth: 1,
            tooltipConfig: {
              backgroundColor: "#d97706",
              textColor: "#ffffff",
            },
          }}
          onStateClick={(stateId) => {
            const office = officeByStateId[stateId];
            if (office) onSelect(office);
          }}
        />
      </div>

      {offices.map((office) => {
        const isActive = office.key === selected.key;

        return (
          <button
            key={office.key}
            type="button"
            onClick={() => onSelect(office)}
            aria-label={`Show ${office.mapLabel} office`}
            className="absolute z-20 flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full transition-transform duration-200 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#d97706]"
            style={{ left: office.marker.x, top: office.marker.y }}
          >
            {isActive && (
              <span className="absolute h-5 w-5 animate-ping rounded-full bg-[#d97706]/40" />
            )}
            <span
              className={`h-[9px] w-[9px] rounded-full border-2 border-white shadow-[0_6px_12px_rgba(119,61,0,0.24)] transition-all duration-200 ${
                isActive ? "scale-110 bg-[#d97706]" : "bg-[#f59e0b]"
              }`}
            />
          </button>
        );
      })}

      <div
        className="pointer-events-none absolute z-30 whitespace-nowrap rounded-[3px] bg-[#d97706] px-[7px] py-[3px] text-[9px] font-extrabold leading-none text-white shadow-[0_8px_16px_rgba(126,56,0,0.18)]"
        style={{
          left: selected.marker.x,
          top: selected.marker.y,
          transform: "translate(-50%, calc(-100% - 8px))",
        }}
      >
        {selected.mapLabel}
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// OfficeCard
// ---------------------------------------------------------------------------

function OfficeCard({ office }) {
  return (
    <div
      className="relative w-[min(100%,190px)] flex-1 overflow-y-auto rounded-[14px] bg-gradient-to-br from-[#fb9a08] via-[#e97900] to-[#cb4a00] p-[12px] text-white shadow-[0_16px_36px_rgba(116,35,0,0.15)] sm:p-[14px]"
      style={{ height: "stretch" }}
    >
      <div className="mb-[10px] inline-flex min-h-[26px] items-center justify-center rounded-[8px] bg-white px-[10px] text-center text-[12px] font-bold leading-tight text-[#c67800]">
        {office.title}
      </div>

      <div className="space-y-[8px] text-[11.5px] leading-[1.35] sm:space-y-[9px] sm:text-[15px]">
        {office.address && (
          <a
            href={mapSearchUrl(office.address)}
            target="_blank"
            rel="noreferrer"
            className="group flex gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 focus-visible:ring-2 focus-visible:ring-white/80"
          >
            <MapPin className="mt-[2px] h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span className="group-hover:underline">{office.address}</span>
          </a>
        )}

        {office.phone ? (
          <a
            href={`tel:${office.phone.replace(/[^0-9+]/g, "")}`}
            className="flex items-center gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 hover:underline focus-visible:ring-2 focus-visible:ring-white/80"
          >
            <Phone className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span>{office.phone}</span>
          </a>
        ) : null}

        {office.email ? (
          <a
            href={`mailto:${office.email}`}
            className="flex items-center gap-[7px] rounded-md outline-none transition-colors hover:text-white/85 hover:underline focus-visible:ring-2 focus-visible:ring-white/80"
          >
            <Mail className="h-[11px] w-[11px] flex-shrink-0 stroke-[2.3]" />
            <span>{office.email}</span>
          </a>
        ) : null}
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Domestic — top-level export, fully self-contained (data + map + card + state)
// ---------------------------------------------------------------------------

export default function Domestic() {
  const [selectedKey, setSelectedKey] = useState("delhi");

  const selectedOffice = useMemo(
    () => offices.find((office) => office.key === selectedKey) || offices[0],
    [selectedKey]
  );

  return (
    <div className="flex flex-col items-center gap-[10px] sm:flex-row sm:items-start sm:justify-center sm:gap-[10px] lg:justify-start">
      <IndiaMap selected={selectedOffice} onSelect={(office) => setSelectedKey(office.key)} />
      <OfficeCard office={selectedOffice} />
    </div>
  );
}